import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { AuthService } from '../services/auth.service';
import { ClienteService } from '../services/cliente.service';
import { PecaService } from '../services/peca.service';
import Swal from 'sweetalert2';
@Component({
	selector: 'app-pecas-edit',
	templateUrl: './pecas-edit.component.html',
	styleUrls: ['./pecas-edit.component.css'],
	animations: [loadingFade]
})
export class PecasEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public peca_id = null;
	public clientes = [];

	public formPeca: FormGroup;
	constructor(private route: ActivatedRoute,
		private fb: FormBuilder,
		private authSvc: AuthService,
		private clienteSvc: ClienteService,
		private pecaSvc: PecaService,
		private router: Router
	) { }

	ngOnInit() {
		this.pegaClientes();
		this.criaForm();
		this.loading = true;

		this.route.params.subscribe(params => {
			if (params.id) {
				this.peca_id = params.id;
				// pega dados a partir do id
				this.pecaSvc.getPeca(params.id).then((data: any) => {
					this.preencheForm({
						peca_id: data.peca_id,
						peca_nome: data.peca_nome,
						peca_validade: data.peca_validade,
						peca_quilometragem: data.peca_quilometragem
					});
					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formPeca = this.fb.group({
			peca_id: null,
			peca_nome: ['', [Validators.required, Validators.maxLength(100)]],
      peca_validade: null,
      peca_quilometragem: null
		});
	}

	preencheForm(dados) {
		this.formPeca.setValue(dados);
	}

	pegaClientes() {
		this.clienteSvc.getClientes().then((data: any) => {
			this.clientes = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	enviaPeca() {
		if (this.formPeca.valid) {
			this.submitting = true;

			let toSend = this.formPeca.value;
			console.log('toSend', toSend)
			if (this.peca_id === null) { // criar
				this.pecaSvc.criaPeca(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Peca cadastrada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/pecas']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.pecaSvc.editaPeca(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Peca alterada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/pecas']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else {
			for (let field in this.formPeca.controls) {
				let campo = this.formPeca.get(field);
				campo.markAsTouched();
			}
			this.submitting = false;
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formPeca.get(nome);
		return input.touched && input.invalid;
	}
}
